import styled from "@emotion/styled";
import { CartViewButtonWrapperProps } from "./CartViewButton.types";
import { colorPalette } from "../../theme/colors";
import { BORDER_RADIUS } from "../../utils/constants";

export const ProductImage = styled.img<{ index: number; isSingle: boolean }>`
  border-radius: 50%;
  width: 36px;
  height: 36px;
  min-width: 36px;
  margin-left: ${(props) => (props.index === 0 ? 0 : -16)}px;
  border: ${(props) =>
    props.isSingle ? `none` : `1px solid ${colorPalette.popWhite[500]}`};
  aspect-ratio: 1/1;
  object-fit: cover;
  flex-shrink: 0;
`;
